/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from '@material-ui/core'
import { useState } from 'react'

import PageHeader from '../../components/PageHeader'
import { getTranslate } from '../../localization'
import { BulkIdCode } from '../../types/accommodation'
import { UserBrief } from '../../types/users'
import AccessButtonSection from './AccessButtonSection'
import ChannelSection from './ChannelSection'
import ProviderSection from './ProviderSection'
import SubscriptionListModal from './SubscriptionListModal'
import useStyles from './styles/index.styles'

function AccessManagement() {
  const classes = useStyles()
  const [accommodationIdCodes, setAccommodationIdCodes] = useState<
    BulkIdCode[]
  >([])
  const [accommodationNamesForTable, setAccommodationNamesForTable] = useState<
    string[]
  >([])
  const [users, setUsers] = useState<UserBrief[]>([])
  const [open, setOpen] = useState(false)
  const [autoCompleteChannelsList, setAutoCompleteChannelsList] =
    useState<any>(null)
  const [autoCompleteTenantValue, setAutoCompleteTenantValue] =
    useState<any>(null)

  return (
    <div>
      <PageHeader title={getTranslate('Access Management')} />
      <div className={classes.header}>
        <Typography variant="h3" gutterBottom>
          {getTranslate('Access Management')}
        </Typography>
        <Typography variant="body1">
          {getTranslate(
            'Provide users access to different accommodations by selecting their names and relevant accommodations and clicking over connect button'
          )}
        </Typography>
      </div>
      <div className={classes.sectionContainer}>
        <ProviderSection
          accommodationIdCodes={accommodationIdCodes}
          setAccommodationIdCodes={setAccommodationIdCodes}
          setAccommodationNamesForTable={setAccommodationNamesForTable}
          autoCompleteTenantValue={autoCompleteTenantValue}
          setAutoCompleteTenantValue={setAutoCompleteTenantValue}
        />
        <AccessButtonSection
          setUsers={setUsers}
          users={users}
          accommodationIdCodes={accommodationIdCodes}
          setAccommodationIdCodes={setAccommodationIdCodes}
          setAccommodationNamesForTable={setAccommodationNamesForTable}
          // accommodationNamesForTable={accommodationNamesForTable}
          setAutoCompleteChannelsList={setAutoCompleteChannelsList}
          setAutoCompleteTenantValue={setAutoCompleteTenantValue}
        />
        <ChannelSection
          setUsers={setUsers}
          users={users}
          autoCompleteChannelsList={autoCompleteChannelsList}
          setAutoCompleteChannelsList={setAutoCompleteChannelsList}
        />
        <SubscriptionListModal open={open} setOpen={setOpen} />
      </div>
    </div>
  )
}

export default AccessManagement
